module.exports = __webpack_public_path__ + "img/00 banner.32003ab5.png";